import {Container, Typography} from "@mui/material";
import React from "react";
import {api} from "../../services/apiService";

import ProductOrOptionForm from "../../components/ProductOrOptionForm";


export default function ProductAdd() {
    const handleSubmit = (formData) => {
        const request = api.post("/products/add", formData)
            .then(response => {
                console.log("Product added:", response.data);
            })
            .catch(error => {
                console.error("Error adding product:", error);
            });

        return request;
    };

    return (
        <Container>
            <Typography variant="h1" gutterBottom>Ajouter un produit</Typography>

            <ProductOrOptionForm onSubmit={handleSubmit}/>
        </Container>
    );
}
